import { styled, media } from '@nx-kit/styling';
import Link, { ComposedLink } from 'components/atoms/Link/Link';
import { teaserDecoration } from 'themes/components/teaser';
import { RichText } from 'components/atoms/RichText';
import { Heading } from 'components/atoms/Heading';
import Icon from 'components/atoms/Icon/Icon';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 0;
  background-color: ${(props) => props.theme.global.color.white};
  margin-bottom: 20px;

  ${teaserDecoration};
`;

export const RowContentStyled = styled.div<{ isEvent: boolean }>`
  display: flex;
  flex-direction: column;
  ${media('lg')} {
    flex-direction: row;
  }
  flex: 1;
  cursor: ${(props) => (props.isEvent ? 'pointer' : '')};
`;

export const RowMapStyled = styled.div`
  flex: 1;
`;

export const ImageStyled = styled.div`
  min-height: 184px;
  height: 184px;
  & img {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0;
  }

  ${media('lg')} {
    min-width: 240px;
    max-width: 240px;
    height: auto;
    flex: 1;
    & img {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      border-top-right-radius: 0;
    }

    &.isOpen img {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
`;

export const DescriptionBoxStyled = styled.div`
  padding: 16px 24px 20px 24px;
  display: flex;
  flex-direction: column;
  flex: 1;

  ${media('lg')} {
    padding: 24px;
  }
`;

export const SeparatorStyled = styled.div`
  border-top: 1px solid ${(props) => props.theme.global.color.gray50};
  margin: 0 24px;
  width: calc(100% - 48px);
  ${media('lg')} {
    padding: 0;

    width: 1px;
    border-top: none;
    border-left: 1px solid ${(props) => props.theme.global.color.gray50};
  }
`;

export const InfoBoxStyled = styled.div`
  padding: 24px;

  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 26px;
  border-left: none;

  ${media('lg')} {
    width: 300px;
  }
`;

export const HeadlineStyled = styled(Heading)`
  margin-bottom: 7px;
`;
export const SubHeadlineStyled = styled.div`
  color: ${(props) => props.theme.global.color.gray180};
  margin-bottom: 10px;
`;

export const RichTextStyled = styled(RichText)`
  p {
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
  }
`;

export const InfoRowStyled = styled.div`
  display: flex;
`;

export const DateStyled = styled.div`
  font-weight: bold;
`;

export const InfoRowMapStyled = styled(InfoRowStyled)`
  margin-top: auto;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: ${(props) => props.theme.global.color.primary};
  &:hover {
    text-decoration: underline;
  }
`;

export const IconWrapperStyled = styled.div`
  width: 35px;
  min-width: 35px;
  text-align: center;
`;

export const IconStyled = styled(Icon)`
  color: ${(props) => props.theme.global.color.primary};
  width: 24px !important;
  height: 24px !important;
  margin-right: 4px;
  margin-top: 2px;
`;

export const LinkToMapStyled = styled(ComposedLink)`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

export const IconMapStyled = styled(Icon)`
  color: ${(props) => props.theme.global.color.primary};
  width: 18px;
  height: 18px;
  margin-top: 0;
`;

export const LinkStyled = styled(Link)`
  color: inherit;
`;

export const SvgImageStyled = styled.image`
  pointer-events: none;
`;
